import axios from "axios";
import BaseService from "../../../../../utils/base.service";
import IRouteValidationResult from "../types/IRouteValidation";
import { IMultiRouteValidationParams } from "../../../../../types/IMissingRailFreight";


export default class RouteValidationService extends BaseService {
  private static async postProxy(
    apiName: string,
    payload: IMultiRouteValidationParams,
  ): Promise<IRouteValidationResult[]> {
    const response = await axios.post(
      `${this.url}/proxy/${apiName}`,
      payload,
    );
    const data = response?.data;
    return Array.isArray(data) ? data : [];
  }

  public static async validate(params: {
    mode: string;
    product: string;
    originLocationId: string;
    originOccupantId: string;
    destinationId: string;
    shipDate: string;
    isCity: boolean;
  }): Promise<IRouteValidationResult> {
    const result = await this.proxy("RouteValidation", params, 1, 1);

    return result[0] as IRouteValidationResult;
  }

  public static async cityMultiValidate(
    params: IMultiRouteValidationParams,
  ): Promise<IRouteValidationResult[]> {
    return this.postProxy("CityMultiRouteValidation", params);
  }

  public static async locationMultiValidate(
    params: IMultiRouteValidationParams,
  ): Promise<IRouteValidationResult[]> {
    return this.postProxy("LocationMultiRouteValidation", params);
  }
}
